import { Scrollbar } from '@aibees/shared/components';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Scrollbar)`
  height: ${(p) => p.theme.spacing(37)};
  gap: ${(p) => p.theme.spacing(1)};
`;
